import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import "../Styles/UserStylings/TopHeader.css";

const TopHeader = () => {
  const { user, logout } = useContext(UserContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/", { replace: true });
  };

  // 🚫 Completely hide top header for seller or admin
  if (user && ["seller", "admin"].includes(user.role?.toLowerCase())) {
    return null;
  }

  return (
    <div className="top-bar">
      <div className="top-bar-content">
        {/* 🌐 Left: Social links */}
        <div className="left-section">
          <span>Follow us on:</span>
          <a
            href="https://www.facebook.com/profile.php?id=61579697636205"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="lab la-facebook"></i> Facebook
          </a>
          <a
            href="https://www.instagram.com/booklocalindia?igsh=b2QzZzcwdG54YTRu"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="lab la-instagram"></i> Instagram
          </a>
          <a
            href="https://www.youtube.com/@BookLocal"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="lab la-youtube"></i> YouTube
          </a>
        </div>

        {/* 👤 Right: Show based on login */}
        <div className="right-section">
          {user ? (
            <>
              <span className="welcome-text">Welcome, {user.name}</span>
              <Link to="/my-account">
                <div className="login-btnn">My Account</div>
              </Link>
              <div className="login-btnn" onClick={handleLogout}>
                Logout
              </div>
            </>
          ) : (
            <>
              <Link to="/login">
                <div className="login-btnn">Login</div>
              </Link>
              <span>or</span>
              <Link to="/signup">
                <div className="login-btnn">Sign Up</div>
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopHeader;
